module.exports = __webpack_public_path__ + "static/media/shield-inactive.f8024cb5.svg";